import { Component, Fragment } from "react";
import { DKLabel, DKTooltipWrapper } from "deskera-ui-library";
import RouteManager, { PAGE_ROUTES } from "../../../managers/RouteManager";
import TenantManager from '../../../managers/TenantManager';
import { isUSCompliance } from "../../../managers/common/CommonUtil";
import { withTranslation } from "react-i18next";
import { TENANT, TenantService } from "../../../managers/TenantManagerService";
import { COUNTRY } from "../../../constants/CountryConstant";
import { isUSStateComplianceEnabled } from "../../compliance/us/ConstantsUS";
import OnboardingWizard from "./OnboardingWizard";
import { ADMIN } from "../../../managers/common/RouteAuth";
import UserManager from "../../../managers/UserManager";

export const ONBOARDING_STEP = {
    companyDetails: "companyDetails",
    employeeDetails: "employeeDetails",
    payrollComponents: "payrollComponents",
    paySchedule: "paySchedule",
    cpfDetails: "cpfDetails",
    taxDetails: "taxDetails",
    bankDetails: "bankDetails",
    filingAuthorization: "filingAuthorization"
};

export const STEP_NAME = {
    companyDetails: "Company Details",
    employeeDetails: "Employee Details",
    payrollComponents: "Earnings and Deductions",
    paySchedule: "Pay Schedule",
    cpfDetails: "CPF Details",
    taxDetails: "Tax Details",
    bankDetails: "Payment Details",
    filingAuthorization: "Filing Authorization" 
};

export const USOnboardingWizardSteps = [
    ONBOARDING_STEP.companyDetails,
    ONBOARDING_STEP.bankDetails,
    ONBOARDING_STEP.taxDetails,
    ONBOARDING_STEP.filingAuthorization
];

class SetupDetails extends Component {
    profileStage;
    incompleteStage = [];

    constructor(props) {
        super(props);
        this.state = {
            stepCompleted: 0,
            totalSteps: [],
            selectedStep: null,
            openWizard: false,
            tenantProfileStages: null
        };
    }

    componentDidMount() {
        this.getProfileData();
    }

    getProfileData() {
        if (this.props.accessedBy === ADMIN) {
            this.profileStage = TenantManager.getProfileData();
        } else {
            this.profileStage = TenantService.get(TENANT.EMPLOYEE_PROFILE_STAGES);
        }

        if (this.profileStage) {
            this.setData();
        }
    }    

    setData() {
        let tenantProfileStages;
        switch (TenantService.get(TENANT.COUNTRY_CODE)) {
            case COUNTRY.IN:
                if(this.props.accessedBy === ADMIN) {
                    tenantProfileStages = [
                        ONBOARDING_STEP.companyDetails,
                        ONBOARDING_STEP.taxDetails,
                        ONBOARDING_STEP.payrollComponents,
                        ONBOARDING_STEP.employeeDetails,
                        ONBOARDING_STEP.paySchedule
                    ];
                } else {
                    tenantProfileStages = [];
                }
            case COUNTRY.US:
                if (isUSStateComplianceEnabled(TenantService.get(TENANT.STATE_CODE))) {
                    if(this.props.accessedBy === ADMIN) {
                        tenantProfileStages = [
                            ONBOARDING_STEP.companyDetails,
                            ONBOARDING_STEP.taxDetails,
                            ONBOARDING_STEP.bankDetails,
                            ONBOARDING_STEP.filingAuthorization,
                            ONBOARDING_STEP.payrollComponents,
                            ONBOARDING_STEP.employeeDetails,
                            ONBOARDING_STEP.paySchedule
                        ];
                    } else {
                        tenantProfileStages = [
                            ONBOARDING_STEP.filingAuthorization
                        ];
                    }
                    
                } else if(this.props.accessedBy === ADMIN) {
                    tenantProfileStages = [
                        ONBOARDING_STEP.companyDetails,
                        ONBOARDING_STEP.taxDetails,
                        ONBOARDING_STEP.payrollComponents,
                        ONBOARDING_STEP.employeeDetails,
                        ONBOARDING_STEP.paySchedule
                    ];
                } else {
                    tenantProfileStages = [];
                }
                break;
            case COUNTRY.SG:
                if(this.props.accessedBy === ADMIN) {
                    tenantProfileStages = [
                        ONBOARDING_STEP.companyDetails,
                        ONBOARDING_STEP.cpfDetails,
                        ONBOARDING_STEP.payrollComponents,
                        ONBOARDING_STEP.employeeDetails,
                        ONBOARDING_STEP.paySchedule
                    ];
                } else {
                    tenantProfileStages = [];
                }
                break;
            case COUNTRY.MY:
                if(this.props.accessedBy === ADMIN) {
                    tenantProfileStages = [
                        ONBOARDING_STEP.companyDetails,
                        ONBOARDING_STEP.payrollComponents,
                        ONBOARDING_STEP.employeeDetails,
                        ONBOARDING_STEP.paySchedule
                    ];
                } else {
                    tenantProfileStages = [];
                }
                break;
            default:
                tenantProfileStages = [];
                break;
        }

        this.setState({
            tenantProfileStages: tenantProfileStages
        });

        const completed = [];
        const inCompleted = [];
        tenantProfileStages.forEach((stage) => {
            if (this.profileStage[stage]) {
                completed.push({
                    id: stage,
                    ...this.getStageDetails(stage)
                });
            } else {
                inCompleted.push({
                    id: stage,
                    ...this.getStageDetails(stage)
                });
            }
        });

        this.incompleteStage = inCompleted;
        this.setState({
            stepCompleted: completed.length,
            totalSteps: [...completed, ...inCompleted]
        });
    }

    getStageDetails(stage) {
        switch (stage) {
            case ONBOARDING_STEP.paySchedule:
                return {
                    name: STEP_NAME.paySchedule,
                    redirectTo: PAGE_ROUTES.PAY_SCHEDULE_LIST
                }
            case ONBOARDING_STEP.taxDetails:
                return {
                    name: STEP_NAME.taxDetails,
                    redirectTo: isUSCompliance() ? PAGE_ROUTES.US_TAX : PAGE_ROUTES.IN_TAX_DETAILS
                }
            case ONBOARDING_STEP.payrollComponents:
                return {
                    name: STEP_NAME.payrollComponents,
                    redirectTo: PAGE_ROUTES.COMPONENT
                }
            case ONBOARDING_STEP.companyDetails:
                return {
                    name: STEP_NAME.companyDetails,
                    redirectTo: PAGE_ROUTES.COMPANY_DETAILS
                }
            case ONBOARDING_STEP.employeeDetails:
                return {
                    name: STEP_NAME.employeeDetails,
                    redirectTo: PAGE_ROUTES.EMPLOYEE_LIST + '/?filter=true'
                }
            case ONBOARDING_STEP.cpfDetails:
                return {
                    name: STEP_NAME.cpfDetails,
                    redirectTo: PAGE_ROUTES.COMPANY_DETAILS
                }
            case ONBOARDING_STEP.bankDetails:
                return {
                    name: STEP_NAME.bankDetails,
                    redirectTo: PAGE_ROUTES.BANK_ACCOUNTS
                }
            case ONBOARDING_STEP.filingAuthorization:
                return {
                    name: STEP_NAME.filingAuthorization,
                    redirectTo: PAGE_ROUTES.FILLING_AUTHORIZATION
                }
            default:
                return {}
        }
    }

    getCompletedPercentage() {
        return Math.round((this.state.stepCompleted / this.state.totalSteps.length) * 100)
    }

    navigateToStep(step) {
        if (TenantService.get(TENANT.COUNTRY_CODE) === COUNTRY.US && USOnboardingWizardSteps.includes(step.id)) {
            this.setState({
                openWizard: true,
                selectedStep: step
            });
        } else {
            RouteManager.navigateToPage(step.redirectTo, step.params);
        }
    }

    getSetupCard() {
        return (
            <div className={`bg-white mt-l border-radius-m border-m ${this.props.className}`}>
                <div className="p-l">
                    <DKLabel className="fw-m fs-xl mb-s" text='Onboarding Steps' />
                    <DKLabel className=" fs-m text-gray mb-s" text={`Your set up is <span class="fw-m text-black">${this.getCompletedPercentage()}%</span> completed`} />
                    {this.getStepper()}
                    <DKLabel className="fw-m fs-m mt-l" text='Things To Do' />
                    {this.getRemainigSteps()}
                </div>
                {this.state.openWizard && this.state.selectedStep &&
                    <OnboardingWizard
                        {...this.props}
                        selectedStep={this.state.selectedStep}
                        tenantProfileStages={this.state.tenantProfileStages}
                        onClose={() => {
                            this.setState({
                                openWizard: false,
                                selectedStep: null
                            });
                            this.getProfileData();
                        }}
                    />
                }
            </div>
        )
    }

    getStepper() {
        let step = this.state.totalSteps.map((data, index) => {
            return (
                <DKTooltipWrapper
                    content={data.name}
                    tooltipClassName="warning-tooltip-prop"
                    className="parent-width p-xs parent-width mr-xs"
                >
                    <div className={`border-radius-m ${index <= this.state.stepCompleted - 1 ? "bg-app" : "bg-light-app" } p-xs parent-width `}></div>
                </DKTooltipWrapper>
            );
        })
        return (
            <div className="d-flex parent-width">
                {step}
            </div>
        )
    }

    getRemainigSteps() {
        const steps = this.incompleteStage.map(stg => {
            return (
                <span
                    style={{
                        whiteSpace: 'nowrap',
                        display: 'inline-block'
                    }}
                    className={`p-v-s p-h-m border-radius-l border-n bg-app text-white mr-m cursor-hand mt-m`}
                    onClick={() => {
                        this.navigateToStep(stg);
                    }}
                >
                    {stg.name}
                </span>
            )
        })
        return (
            <div className="text-align-left" style={{ wordBreak: 'break-all' }}>
                {steps}
            </div>
        )
    }

    render() {
        return (
            <>
                {this.incompleteStage.length != 0 && this.getSetupCard()}
            </>
        )
    }
}

export default withTranslation()(SetupDetails)
